import React, { useState } from 'react'
import { FaBriefcase } from 'react-icons/fa'
import OutsideAlerter from '../../hooks/ClickOutside'
import {
    StyledRefreshBroker,
    StyledMoreContainer,
    StyledDropDownMenu,
    StyledMenuItem,
    StyledDivider,
    StyledMenuItemLink,
} from './styles'
import { useTheme } from 'styled-components'

export default function RefreshBroker(props: {
    refreshBroker: () => void
    refreshTransactions: () => void
}) {
    const theme = useTheme()
    const { refreshBroker, refreshTransactions } = props
    const [isOpened, SetIsOpened] = useState(false)

    return (
        <StyledRefreshBroker>
            <StyledMoreContainer>
                <OutsideAlerter
                    onpress={() => {
                        SetIsOpened(false)
                    }}
                >
                    <FaBriefcase
                        color={theme.colours.font.primary}
                        onClick={() => SetIsOpened(!isOpened)}
                    />
                    {isOpened ? (
                        <StyledDropDownMenu>
                            <StyledMenuItem>
                                <StyledMenuItemLink
                                    href="https://wisesheets.io/connect-brokerage/manage"
                                    target="_blank"
                                >
                                    Manage Broker Connections
                                </StyledMenuItemLink>
                            </StyledMenuItem>
                            <StyledDivider />
                            <StyledMenuItem onClick={() => refreshBroker()}>
                                Refresh Holdings
                            </StyledMenuItem>
                            <StyledDivider />
                            <StyledMenuItem
                                onClick={() => refreshTransactions()}
                            >
                                Refresh Transactions
                            </StyledMenuItem>
                        </StyledDropDownMenu>
                    ) : null}
                </OutsideAlerter>
            </StyledMoreContainer>
        </StyledRefreshBroker>
    )
}
